import React from "react";

import type { MainMenuGroup } from "../../../common/openapi/models";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export interface GroupViewsIndexBreadcrumbProps {
	to?: string;
	group: MainMenuGroup;
}

export const GroupViewsIndexBreadcrumb: React.FC<GroupViewsIndexBreadcrumbProps> = ({ group, ...props }) => (
	<BreadcrumbLayout
		{...props}
		icon={group.icon ? <img alt="icon" className="h-[18px] w-[18px] max-w-none" src={group.icon} /> : null}
		label={group.name}
	/>
);
